import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FormBuilder from '../../../../common/form-builder/FormBuilder';

export default function EquipmentForm() {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const inertGas = [
    {
      name: 'Flue Gas',
    },
    {
      name: 'ICG',
    },
    {
      name: 'Nitrogen Generator',
    },
  ];

  const esd = [
    {
      name: 'Yes',
    },
    {
      name: 'No',
    },
  ];

  const esdType = [
    {
      name: 'Pnuematic',
    },
    {
      name: 'Electrical',
    },
    {
      name: 'Optical Fiber',
    },
  ];

  const pedestalRoller = [
    {
      name: 'Yes',
    },
    {
      name: 'No',
    },
    {
      name: 'NA',
    },
  ];

  const equipmentFormConfig = [
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'propeller',
      label: t('labels.propeller'),
      control: control,
      fieldType: 'number',
      maxLength: 7,
      rules: [
        {
          type: 'pattern',
          pattern: '^[0-9]*$',
          message: t('errors.wholeNumber'),
        },
      ],
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'propellerDescription',
      label: t('labels.propellerDescription'),
      control: control,
      fieldType: 'text',
      maxLength: 50,
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'propulsionType',
      label: t('labels.propellingType'),
      control: control,
      fieldType: 'text',
      maxLength: 30,
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'manifold',
      label: t('labels.manifold'),
      control: control,
      fieldType: 'text',
      maxLength: 50,
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'manifoldSize',
      label: t('labels.manifoldSize'),
      control: control,
      fieldType: 'text',
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'inertGas',
      label: t('labels.inertGas'),
      control: control,
      fieldType: 'select',
      dataSource: inertGas,
      displayExpr: 'name',
      valueExpr: 'name',
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'numberOfCranes',
      label: t('labels.numberOfCranes'),
      control: control,
      fieldType: 'number',
      maxLength: 7,
      rules: [
        {
          type: 'pattern',
          pattern: '^[0-9]*$',
          message: t('errors.wholeNumber'),
        },
      ],
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'craneSWL',
      label: t('labels.craneSWL'),
      control: control,
      fieldType: 'number',
      allowDecimal: true,
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'bowStoppersNo',
      label: t('labels.chainStoppersNos'),
      control: control,
      fieldType: 'number',
      maxLength: 7,
      rules: [
        {
          type: 'pattern',
          pattern: '^[0-9]*$',
          message: t('errors.wholeNumber'),
        },
      ],
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'bowStoppersSWL',
      label: t('labels.chainStopperSWL'),
      control: control,
      fieldType: 'number',
      allowDecimal: true,
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'mooringRope',
      label: t('labels.mooringRope'),
      control: control,
      fieldType: 'number',
      maxLength: 7,
      rules: [
        {
          type: 'pattern',
          pattern: '^[0-9]*$',
          message: t('errors.wholeNumber'),
        },
      ],
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'mooringRopeMaterial',
      label: t('labels.mooringRopeMaterial'),
      control: control,
      fieldType: 'text',
      maxLength: 50,
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'mooringRopeMBL',
      label: t('labels.mooringRopeMBL'),
      control: control,
      fieldType: 'text',
      maxLength: 50,
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'mooringDrums',
      label: t('labels.mooringDrums'),
      control: control,
      fieldType: 'number',
      maxLength: 7,
      rules: [
        {
          type: 'pattern',
          pattern: '^[0-9]*$',
          message: t('errors.wholeNumber'),
        },
      ],
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'equipmentESD',
      label: t('labels.esd'),
      control: control,
      fieldType: 'select',
      dataSource: esd,
      displayExpr: 'name',
      valueExpr: 'name',
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'equipmentESDType',
      label: t('labels.esdType'),
      control: control,
      fieldType: 'select',
      dataSource: esdType,
      displayExpr: 'name',
      valueExpr: 'name',
    },
  ];

  const fwdFormConfig = [
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'fwdSwl',
      label: t('labels.swl'),
      control: control,
      fieldType: 'number',
      allowDecimal: true,
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'fwdType',
      label: t('labels.type'),
      control: control,
      fieldType: 'text',
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'fwdPedestalRoller',
      label: t('labels.pedestalRoller'),
      control: control,
      fieldType: 'select',
      dataSource: pedestalRoller,
      displayExpr: 'name',
      valueExpr: 'name',
    },
  ];

  const aftFormConfig = [
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'aftSwl',
      label: t('labels.swl'),
      control: control,
      fieldType: 'number',
      allowDecimal: true,
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'aftType',
      label: t('labels.type'),
      control: control,
      fieldType: 'text',
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'aftPedestalRoller',
      label: t('labels.pedestalRoller'),
      control: control,
      fieldType: 'select',
      dataSource: pedestalRoller,
      displayExpr: 'name',
      valueExpr: 'name',
    },
  ];

  const blankForm = [
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'blankNineteen',
      label: t('labels.blankNineteen'),
      control: control,
      fieldType: 'number',
      allowDecimal: true,
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'blankTwenty',
      label: t('labels.blankTwenty'),
      control: control,
      fieldType: 'text',
    },
    {
      class:
        'col-md-3 col-sm-6 col-lg-3 col-xs-12 m-l-custom-sixteen-space-col',
      name: 'blankTwentyOne',
      label: t('labels.blankTwentyOne'),
      control: control,
      fieldType: 'text',
    },
  ];

  return (
    <>
      <div className="row">
        <FormBuilder formConfig={equipmentFormConfig} />
      </div>
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 m-l-ads-table-items m-l-custom-sixteen-space-col">
        <div className="m-l-details-page-sepeartor"></div>
      </div>
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 m-l-ads-table-items m-l-custom-sixteen-space-col">
        <div className="m-l-details-page-small-heading">{t('labels.spm')}</div>
      </div>
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 m-l-ads-table-items m-l-custom-sixteen-space-col">
          <div className="m-l-details-page-extra-small-heading">
            {t('labels.fwd')}
          </div>
        </div>
        <FormBuilder formConfig={fwdFormConfig} />
      </div>
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 m-l-ads-table-items m-l-custom-sixteen-space-col">
          <div className="m-l-details-page-extra-small-heading">
            {t('labels.aft')}
          </div>
        </div>
        <FormBuilder formConfig={aftFormConfig} />
      </div>
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 u-mb-xl m-l-ads-table-items m-l-custom-sixteen-space-col">
          <div className="m-l-details-page-sepeartor"></div>
        </div>
        <FormBuilder formConfig={blankForm} />
      </div>
    </>
  );
}
